import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Card, Grid, Header, Item, Segment } from 'semantic-ui-react';
import SponsorCard from '../components/sponsors/SponsorCard';
import { useScreenConfig } from '../config/screens.context';
import store from '../shared/Store';
import { SponsorItem } from '../sponsors/Sponsors';
import { getString, throttleDispatchFetch } from '../utils';
import { useOrderBy } from '../utils/hooks';
import './Programs.scss';
import { fetchPrograms } from './store/programs.actions';

const translationPrefix = 'programs';

const throttledFetch = throttleDispatchFetch(() => store.reduxStore.dispatch(fetchPrograms()));

const defaultOrder = [{ field: 'name', order: 'asc' }];

const Programs = ({ name, mode, programs }) => {
  useEffect(() => {
    throttledFetch();
  }, []);
  const { orderBy: orderByConfig = defaultOrder } = useScreenConfig('programs');
  const finalPrograms = useOrderBy(programs, orderByConfig);

  return (
    <div className={`screen screen--type-program screen--${name}`}>
      <Grid>
        {mode === 'grid' && (
          <Grid.Column>
            <Card.Group>
              {finalPrograms.map((item) => (
                <SponsorCard key={item._id} type="program" item={item} />
              ))}
            </Card.Group>
          </Grid.Column>
        )}
        {mode === 'list' && (
          <Grid.Column>
            <Segment>
              <Header as="h3">
                {finalPrograms.length} {getString(`${translationPrefix}.programs`)}
              </Header>
              <Item.Group divided>
                {finalPrograms.map((item) => (
                  <SponsorItem key={item._id} sponsor={item} />
                ))}
              </Item.Group>
            </Segment>
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
};

Programs.defaultProps = {
  mode: 'grid',
  programs: [],
};

Programs.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.oneOf(['grid', 'list']),
};

const mapStateToProps = (state) => ({
  ...state.workshops,
  ...state.programs,
});

export default connect(mapStateToProps)(Programs);
